/**
 * M10.3: civilization emblems, drawn by id (catalogue: CIV_EMBLEMS in @galaxis/shared).
 * New emblems: add an id there and a path here; unknown ids fall back to "nova".
 */
const PATHS: Record<string, string> = {
  nova: 'M12 2l2.4 7.2H22l-6 4.6 2.3 7.2L12 16.6 5.7 21l2.3-7.2-6-4.6h7.6z',
  orbit: 'M12 9a3 3 0 110 6 3 3 0 010-6zm0-6c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9zm0 2a7 7 0 100 14 7 7 0 000-14z',
  crown: 'M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5z',
  helix: 'M7 3c0 6 10 6 10 12v6h-2v-6c0-4.5-10-4.5-10-12zm10 0h-2c0 2-1.2 3.2-3 4.2l1.3 1.4C15.6 7.3 17 5.6 17 3zM7 21h2c0-2 1.2-3.2 3-4.2l-1.3-1.4C8.4 16.7 7 18.4 7 21z',
  shield: 'M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z',
  comet: 'M19 5a4 4 0 11-5.7 5.6L4 20l-1-1 9.3-9.3A4 4 0 0119 5z',
  eye: 'M12 5c5 0 9 4.5 10 7-1 2.5-5 7-10 7S3 14.5 2 12c1-2.5 5-7 10-7zm0 3a4 4 0 100 8 4 4 0 000-8z',
  trident: 'M11 2h2v5l2-3h2l-3 5h-1v13h-2V9h-1L7 4h2l2 3z',
  phoenix: 'M12 3c1 3 4 4 7 3-1 3-3 5-5 5 2 1 3 3 3 6-2-1-3-2-5-2s-3 1-5 2c0-3 1-5 3-6-2 0-4-2-5-5 3 1 6 0 7-3z',
  gear: 'M10 2h4l.6 2.6 2.3 1 2.3-1.4 2.8 2.8-1.4 2.3 1 2.3L22 12v.1l-.4 2.4-2.3 1 1.4 2.3-2.8 2.8-2.3-1.4-2.3 1L14 22h-4l-.6-2.6-2.3-1-2.3 1.4-2.8-2.8 1.4-2.3-1-2.3L2 12l2.6-.6 1-2.3-1.4-2.3 2.8-2.8 2.3 1.4 2.3-1zm2 6a4 4 0 100 8 4 4 0 000-8z',
  leaf: 'M20 3C9 3 4 9 4 15c0 2 .6 3.7 1.6 5L4 21.6 5.4 23l1.7-1.7C8.3 22.4 10 23 12 23c6 0 9-6 8-20z',
  spiral: 'M12 12c0-1 1-1.5 1.8-1 .9.6.8 2.2-.3 3-1.6 1.1-4 .3-4.6-1.8-.8-2.8 1.5-5.6 4.6-5.6 3.8 0 6.4 3.8 5.3 7.5-1.2 4.4-6.3 6.5-10.3 4.6C4.6 16.9 3.2 11.5 5.8 7.7',
};

export function Emblem({ id, color, size = 24, title }: { id: string; color: string; size?: number; title?: string }) {
  const d = PATHS[id] ?? PATHS['nova']!;
  const stroke = id === 'spiral';
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" role={title ? 'img' : undefined} aria-label={title} aria-hidden={title ? undefined : true}>
      <path d={d} fill={stroke ? 'none' : color} stroke={stroke ? color : 'none'} strokeWidth={stroke ? 2 : 0} strokeLinecap="round" />
    </svg>
  );
}

/** Round badge: emblem on a tinted disc in the civilization color. */
export function EmblemBadge({ id, color, size = 40, title }: { id: string; color: string; size?: number; title?: string }) {
  return (
    <span className="inline-flex items-center justify-center rounded-full flex-shrink-0"
      style={{ width: size, height: size, background: `${color}22`, border: `2px solid ${color}88` }}>
      <Emblem id={id} color={color} size={Math.round(size * 0.58)} title={title} />
    </span>
  );
}
